import { ErrorCode } from '@ethersproject/logger'
import { UserRejectedError } from '../errors/userReject'

export function handleWasmSdkError(e: string | any) {
  if (typeof e === 'string') {
    if (e.indexOf(ErrorCode.ACTION_REJECTED) > -1) {
      throw new UserRejectedError(e)
    }
    throw new Error(e)
  }
  throw e
}
